import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthenticationGuardService } from "./authentication/authentication-guard.service";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "userClients",
    loadChildren: () =>
      import("./UserClients/UserClients.module").then(
        (m) => m.UserClientsPageModule
      ),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "loginRegistration",
    loadChildren: () =>
      import("./loginRegistration/loginRegistration.module").then(
        (m) => m.LoginRegistrationPageModule
      ),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "clientLanding",
    loadChildren: () =>
      import("./clientLanding/clientLanding.module").then(
        (m) => m.ClientLandingPageModule
      ),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "publishedLessons",
    loadChildren: () =>
      import("./publishedLessons/publishedLessons.module").then(
        (m) => m.PublishedLessonsPageModule
      ),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "userRegistration",
    loadChildren: () =>
      import("./userRegistration/userRegistration.module").then(
        (m) => m.UserRegistrationPageModule
      ),
    //loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: "home",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "people",
    loadChildren: () =>
      import("./people/people.module").then((m) => m.PeoplePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "people/people-edit",
    loadChildren: () =>
      import("./people/people-edit/people-edit.module").then(
        (m) => m.PeopleEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "peopleSimplified",
    loadChildren: () =>
      import("./peopleSimplified/peopleSimplified.module").then(
        (m) => m.PeopleSimplifiedPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "peopleSimplified/peopleSimplified-edit",
    loadChildren: () =>
      import(
        "./peopleSimplified/peopleSimplified-edit/peopleSimplified-edit.module"
      ).then((m) => m.PeopleSimplifiedEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "peopleGroups",
    loadChildren: () =>
      import("./peopleGroups/peopleGroups.module").then(
        (m) => m.PeopleGroupsPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "peopleGroups/peopleGroups-edit",
    loadChildren: () =>
      import("./peopleGroups/peopleGroups-edit/peopleGroups-edit.module").then(
        (m) => m.PeopleGroupsEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "lessons",
    loadChildren: () =>
      import("./lessons/lessons.module").then((m) => m.LessonsPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "end-session",
    loadChildren: () =>
      import("./end-session/end-session.module").then(
        (m) => m.EndSessionPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "importPeople",
    loadChildren: () =>
      import("./importPeople/importPeople.module").then(
        (m) => m.ImportPeoplePageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "siteAssignment",
    loadChildren: () =>
      import("./siteAssignment/siteAssignment.module").then(
        (m) => m.SiteAssignmenPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "lessons/lesson-edit",
    loadChildren: () =>
      import("./lessons/lesson-edit/lesson-edit.module").then(
        (m) => m.LessonEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  // {
  //   path: "media",
  //   loadChildren: () =>
  //     import("./media/media.module").then((m) => m.MediaPageModule),
  //   canActivate: [AuthenticationGuardService],
  // },
  // {
  //   path: "media/media-edit",
  //   loadChildren: () =>
  //     import("./media/media-edit/media-edit.module").then(
  //       (m) => m.MediaEditPageModule
  //     ),
  //   canActivate: [AuthenticationGuardService],
  // },
  {
    path: "training",
    loadChildren: () =>
      import("./training/training.module").then((m) => m.TrainingPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "messages",
    loadChildren: () =>
      import("./messages/messages.module").then((m) => m.MessagesPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "datalists",
    loadChildren: () =>
      import("./landingPages/datalists/datalists.module").then(
        (m) => m.DataListsPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "regions",
    loadChildren: () =>
      import("./regions/regions.module").then((m) => m.RegionsPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "regions/regions-edit",
    loadChildren: () =>
      import("./regions/regions-edit/regions-edit.module").then(
        (m) => m.RegionsEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "site",
    loadChildren: () =>
      import("./site/site.module").then((m) => m.SitePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "site/site-edit",
    loadChildren: () =>
      import("./site/site-edit/site-edit.module").then(
        (m) => m.SiteEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "workArea",
    loadChildren: () =>
      import("./workArea/workArea.module").then((m) => m.WorkAreaPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "workArea/workArea-edit",
    loadChildren: () =>
      import("./workArea/workArea-edit/workArea-edit.module").then(
        (m) => m.WorkAreaEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "title",
    loadChildren: () =>
      import("./title/title.module").then((m) => m.TitlePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "title/title-edit",
    loadChildren: () =>
      import("./title/title-edit/title-edit.module").then(
        (m) => m.TitleEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "village",
    loadChildren: () =>
      import("./village/village.module").then((m) => m.VillagePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "village/village-edit",
    loadChildren: () =>
      import("./village/village-edit/village-edit.module").then(
        (m) => m.VillageEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "jobTitle",
    loadChildren: () =>
      import("./jobTitle/jobTitle.module").then((m) => m.JobTitlePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "jobTitle/jobTitle-edit",
    loadChildren: () =>
      import("./jobTitle/jobTitle-edit/jobTitle-edit.module").then(
        (m) => m.JobTitleEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "department",
    loadChildren: () =>
      import("./department/department.module").then(
        (m) => m.DepartmentPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "department/department-edit",
    loadChildren: () =>
      import("./department/department-edit/department-edit.module").then(
        (m) => m.DepartmentEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "workSchedule",
    loadChildren: () =>
      import("./workSchedule/workSchedule.module").then(
        (m) => m.WorkSchedulePageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "workSchedule/workSchedule-edit",
    loadChildren: () =>
      import("./workSchedule/workSchedule-edit/workSchedule-edit.module").then(
        (m) => m.WorkScheduleEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "housingStatus",
    loadChildren: () =>
      import("./housingStatus/housingStatus.module").then(
        (m) => m.HousingStatusPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "housingStatus/housingStatus-edit",
    loadChildren: () =>
      import(
        "./housingStatus/housingStatus-edit/housingStatus-edit.module"
      ).then((m) => m.HousingStatusEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "mineRentalType",
    loadChildren: () =>
      import("./mineRentalType/mineRentalType.module").then(
        (m) => m.MineRentalTypePageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "mineRentalType/mineRentalType-edit",
    loadChildren: () =>
      import(
        "./mineRentalType/mineRentalType-edit/mineRentalType-edit.module"
      ).then((m) => m.MineRentalTypeEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "race",
    loadChildren: () =>
      import("./race/race.module").then((m) => m.RacePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "race/race-edit",
    loadChildren: () =>
      import("./race/race-edit/race-edit.module").then(
        (m) => m.RaceEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "qualifications",
    loadChildren: () =>
      import("./qualifications/qualification.module").then(
        (m) => m.QualificationPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "qualifications/qualification-edit",
    loadChildren: () =>
      import(
        "./qualifications/qualification-edit/qualification-edit.module"
      ).then((m) => m.QualificationEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "license",
    loadChildren: () =>
      import("./license/license.module").then((m) => m.LicensePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "license/license-edit",
    loadChildren: () =>
      import("./license/license-edit/license-edit.module").then(
        (m) => m.LicenseEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "pricePlan",
    loadChildren: () =>
      import("./pricePlan/pricePlan.module").then((m) => m.PricePlanPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "pricePlan/pricePlan-edit",
    loadChildren: () =>
      import("./pricePlan/pricePlan-edit/pricePlan-edit.module").then(
        (m) => m.PricePlanEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "subscription",
    loadChildren: () =>
      import("./subscription/subscription.module").then(
        (m) => m.SubscriptionPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "subscription/subscription-edit",
    loadChildren: () =>
      import("./subscription/subscription-edit/subscription-edit.module").then(
        (m) => m.SubscriptionEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "procedure",
    loadChildren: () =>
      import("./procedure/procedure.module").then((m) => m.ProcedurePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "procedure/procedure-edit",
    loadChildren: () =>
      import("./procedure/procedure-edit/procedure-edit.module").then(
        (m) => m.ProcedureEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "procedureSigned",
    loadChildren: () =>
      import("./procedureSigned/procedureSigned.module").then(
        (m) => m.ProcedureSignedPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "procedureSigned/procedureSigned-edit",
    loadChildren: () =>
      import(
        "./procedureSigned/procedureSigned-edit/procedureSigned-edit.module"
      ).then((m) => m.ProcedureSignedEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "form",
    loadChildren: () =>
      import("./form/form.module").then((m) => m.FormPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "form/form-edit",
    loadChildren: () =>
      import("./form/form-edit/form-edit.module").then(
        (m) => m.FormEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "report",
    loadChildren: () =>
      import("./report/report.module").then((m) => m.ReportPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "report/report-edit",
    loadChildren: () =>
      import("./report/report-edit/report-edit.module").then(
        (m) => m.ReportEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "configuration",
    loadChildren: () =>
      import("./configuration/configuration.module").then(
        (m) => m.ConfigurationPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "contractor",
    loadChildren: () =>
      import("./contractor/contractor.module").then(
        (m) => m.ContractorPageModule
      ),
    canActivate: [],
  },
  {
    path: "contractor/contractor-edit",
    loadChildren: () =>
      import("./contractor/contractor-edit/contractor-edit.module").then(
        (m) => m.ContractorEditPageModule
      ),
    //canActivate: [AuthenticationGuardService]
  },
  {
    path: "distributionList",
    loadChildren: () =>
      import("./distributionList/distributionList.module").then(
        (m) => m.DistributionListPageModule
      ),
    canActivate: [],
  },
  {
    path: "distributionList/distributionList-edit",
    loadChildren: () =>
      import(
        "./distributionList/distributionList-edit/distributionList-edit.module"
      ).then((m) => m.DistributionListEditPageModule),
    //canActivate: [AuthenticationGuardService]
  },
  {
    path: "sow",
    loadChildren: () => import("./sow/sow.module").then((m) => m.SOWPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "sow/sow-edit",
    loadChildren: () =>
      import("./sow/sow-edit/sow-edit.module").then((m) => m.SOWEditPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "visitors",
    loadChildren: () =>
      import("./visitors/visitors.module").then((m) => m.VisitorsPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "visitors/visitors-edit",
    loadChildren: () =>
      import("./visitors/visitors-edit/visitors-edit.module").then(
        (m) => m.VisitorsEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "equipment",
    loadChildren: () =>
      import("./equipment/equipment.module").then((m) => m.EquipmentPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "equipment/equipment-edit",
    loadChildren: () =>
      import("./equipment/equipment-edit/equipment-edit.module").then(
        (m) => m.EquipmentEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "vehicle",
    loadChildren: () =>
      import("./vehicle/vehicle.module").then((m) => m.VehiclePageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "vehicle/vehicle-edit",
    loadChildren: () =>
      import("./vehicle/vehicle-edit/vehicle-edit.module").then(
        (m) => m.VehicleEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "chemical",
    loadChildren: () =>
      import("./chemical/chemical.module").then((m) => m.ChemicalPageModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "chemical/chemical-edit",
    loadChildren: () =>
      import("./chemical/chemical-edit/chemical-edit.module").then(
        (m) => m.ChemicalEditPageModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: "training-centre",
    loadChildren: () =>
      import("./landingPages/training-centre/training-centre.module").then(
        (m) => m.TrainingCentrePageModule
      ),
  },
  {
    path: "resource-manager",
    loadChildren: () =>
      import("./landingPages/resource-manager/resource-manager.module").then(
        (m) => m.ResourceManagerPageModule
      ),
  },
  {
    path: "administration",
    loadChildren: () =>
      import("./landingPages/administration/administration.module").then(
        (m) => m.AdministrationPageModule
      ),
  },
  {
    path: "procedure-manager",
    loadChildren: () =>
      import("./landingPages/procedure-manager/procedure-manager.module").then(
        (m) => m.ProcedureManagerPageModule
      ),
  },
  //{ path: 'procedures', loadChildren: './landingPages/procedures/procedures.module#ProceduresPageModule' },
  {
    path: "projects",
    loadChildren: () =>
      import("./landingPages/projects/projects.module").then(
        (m) => m.ProjectsPageModule
      ),
  },
  {
    path: "lesson-builder",
    loadChildren: () =>
      import("./landingPages/lesson-builder/lesson-builder.module").then(
        (m) => m.LessonBuilderPageModule
      ),
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./landingPages/profile/profile.module").then(
        (m) => m.ProfilePageModule
      ),
  },
  {
    path: "registrationFinalization",
    loadChildren: () =>
      import("./registrationFinalization/registrationFinalization.module").then(
        (m) => m.RegistrationFinalizationPageModule
      ),
  },
  {
    path: "licenseFinalization",
    loadChildren: () =>
      import("./licenseFinalization/licenseFinalization.module").then(
        (m) => m.LicenseFinalizationPageModule
      ),
  },
  {
    path: "distributionList",
    loadChildren: () =>
      import("./distributionList/distributionList.module").then(
        (m) => m.DistributionListPageModule
      ),
  },
  {
    path: "distributionList-edit",
    loadChildren: () =>
      import(
        "./distributionList/distributionList-edit/distributionList-edit.module"
      ).then((m) => m.DistributionListEditPageModule),
  },
  {
    path: "department",
    loadChildren: () =>
      import("./department/department.module").then(
        (m) => m.DepartmentPageModule
      ),
  },
  {
    path: "procedure-modal",
    loadChildren: () =>
      import("./modals/procedure-modal/procedure-modal.module").then(
        (m) => m.ProcedureModalPageModule
      ),
  },
  {
    path: "datepicker-modal",
    loadChildren: () =>
      import("./modals/datepicker-modal/datepicker-modal.module").then(
        (m) => m.DatepickerModalPageModule
      ),
  },
  {
    path: "assignments",
    loadChildren: () =>
      import("./assignments/assignments.module").then(
        (m) => m.AssignmentPageModule
      ),
  },

  {
    path: "users",
    loadChildren: () =>
      import("./peopleSimplified/users/users.module").then(
        (m) => m.UsersPageModule
      ),
  },
  {
    path: "contractor-config",
    loadChildren: () =>
      import("./landingPages/contractor-config/contractor-config.module").then(
        (m) => m.ContractorConfigPageModule
      ),
  },
  {
    path: "siteMetrics",
    loadChildren: () =>
      import("./metrics/siteMetrics/siteMetric.module").then(
        (m) => m.SiteMetricPageModule
      ),
  },
  {
    path: "lessonMetrics",
    loadChildren: () =>
      import("./metrics/lessonMetrics/lessonMetric.module").then(
        (m) => m.LessonMetricPageModule
      ),
  },
  {
    path: "userMetrics",
    loadChildren: () =>
      import("./metrics/userMetrics/userMetric.module").then(
        (m) => m.UserMetricPageModule
      ),
  },
  {
    path: "groupMetrics",
    loadChildren: () =>
      import("./metrics/groupMetrics/groupMetric.module").then(
        (m) => m.GroupMetricPageModule
      ),
  },
  {
    path: "manage-content",
    loadChildren: () =>
      import("./manage-content/manage-content.module").then(
        (m) => m.ManageContentPageModule
      ),
  },
  {
    path: "resources",
    loadChildren: () =>
      import("./landingPages/resources/resources.module").then(
        (m) => m.ResourcesPageModule
      ),
  },
  {
    path: "tutorialVids",
    loadChildren: () =>
      import("./modals/tutorialVideos/tutorialVids.module").then(
        (m) => m.TutorialVidsComponentModule
      ),
  },

  //{ path: 'home', loadChildren: './landingPages/home/home.module#HomePageModule' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
